<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div id="page-accordion">
      <!-- masterdata -->
      <div class="card" [ngClass]="activeTab === 'masterdata' ? 'active' : ''" [formGroup]="formGroup">
        <div class="card-title px-2 mb-0" (click)="changeTab('masterdata')">
          <h4 class="mb-0">{{ "MASTERDATA" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'masterdata' ? 'card-body' : ''" class="row">
          <div class="form-group col-xl-3 col-md-6 col-12" [ngClass.xl]="formGroup.value.type === 'Stagista' || formGroup.value.type === 'Prestazione occasionale' ? 'col-xl-4 col-md-6' : 'col-xl-3 col-md-6'">
            <label for="type">{{ "TYPE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              [formControlName]="'type'"
              id="type"
              bindLabel="nice_name"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              (change)="changeTypeUser($any($event))"
              [readonly]="true"
              placeholder="{{ 'TYPE' | translate }}"
              [items]="typeCollaborator"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
            </ng-select>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12" [ngClass.xl]="formGroup.value.type === 'Stagista' || formGroup.value.type === 'Prestazione occasionale' ? 'col-xl-4 col-md-6' : 'col-xl-3 col-md-6'">
            <label for="firstname">{{ "FIRSTNAME" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="firstname" maxlength="50" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" [formControlName]="'firstname'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.firstname.errors?.required">{{ "ERRORS.INSERT_NAME" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12" [ngClass.xl]="formGroup.value.type === 'Stagista' || formGroup.value.type === 'Prestazione occasionale' ? 'col-xl-4 col-md-6' : 'col-xl-3 col-md-6'">
            <label for="lastname">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="lastname" maxlength="50" class="form-control  {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" [formControlName]="'lastname'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.lastname.errors?.required">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva'">
            <label for="business_name">{{ "BUSINESS_NAME" | translate }}<sup class="text-danger" *ngIf="formGroup.value.business_name && formGroup.value.business_name.length > 0">*</sup></label>
            <input type="text" id="business_name" maxlength="100" class="form-control {{ fieldHasErrors('business_name') ? 'is-invalid' : '' }}" [formControlName]="'business_name'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.lastname.errors?.required">{{ "ERRORS.FIELD_BUSINESS_NAME" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="figure_id">{{ "FIGURE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              bindValue="id"
              bindLabel="name"
              id="figure_id"
              class="{{ fieldHasErrors('figure_id') ? 'is-invalid' : '' }}"
              formControlName="figure_id"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [items]="_userFigureService.list"
            ></ng-select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.figure_id.errors?.required">{{ "ERRORS.FIELD_FIGURE" | translate }}</div>
          </div>
          <div
            class="form-group col-xl-3 col-md-6 col-12"
            [ngClass.xl]="formGroup.value.type === 'Stagista' || formGroup.value.type === 'Prestazione occasionale' ? 'col-xl-4' : 'col-xl-3'"
            *ngIf="formGroup.value.type === 'Da fornitore'"
          >
            <label for="type">{{ "TITLES.USERS_TYPES_SINGULAR.external" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              [formControlName]="'provider_id'"
              id="provider_id"
              bindLabel="name"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              placeholder="{{ 'TITLES.USERS_TYPES_SINGULAR.external' | translate }}"
              [items]="providers"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
            </ng-select>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="private_email">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="private_email" maxlength="255" class="form-control {{ fieldHasErrors('private_email') ? 'is-invalid' : '' }}" [formControlName]="'private_email'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.private_email.errors?.required">{{ "ERRORS.INSERT_PRIVATE_EMAIL" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="phone">{{ "PHONE" | translate }}<sup class="text-danger" *ngIf="formGroup.value.type !== 'Da fornitore'">*</sup></label>
            <input type="tel" id="phone" maxlength="20" class="form-control {{ fieldHasErrors('phone') ? 'is-invalid' : '' }}" [formControlName]="'phone'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.phone.errors?.required">{{ "ERRORS.INSERT_PRIVATE_PHONE" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.phone?.errors?.minlength">{{ "MIN" | translate }} 9 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.phone?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.phone?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="fiscalcode">{{ "FISCAL_CODE" | translate }}<sup class="text-danger" *ngIf="formGroup.value.type === 'Stagista' || formGroup.value.type === 'Prestazione occasionale'">*</sup></label>
            <input type="text" id="fiscalcode" maxlength="20" class="form-control {{ fieldHasErrors('fiscalcode') ? 'is-invalid' : '' }}" [formControlName]="'fiscalcode'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.fiscalcode.errors?.required">{{ "ERRORS.INSERT_FISCAL_CODE" | translate }}</div>
          </div>
          <div class="form-group col-md-6 col-xl-{{ formGroup.value.type !== 'Stagista' ? '4' : '3' }} col-12">
            <label for="email">{{ "USER_OFFICE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="email" maxlength="255" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" [formControlName]="'email'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.email.errors?.required">{{ "ERRORS.INSERT_OFFICE_EMAIL" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.email?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
          </div>
          <div class="form-group col-md-6 col-xl-{{ formGroup.value.type !== 'Stagista' ? '4' : '3' }} col-12">
            <label for="birthday">{{ "BIRTHDAY" | translate }}</label>
            <input type="date" id="birthday" [max]="min_birthdate" class="form-control {{ fieldHasErrors('birthday') ? 'is-invalid' : '' }}" formControlName="birthday" />
          </div>
          <div class="form-group col-xl-{{ formGroup.value.type !== 'Stagista' ? '4' : '3' }} col-md-6 col-12">
            <label for="sex">{{ "GENDER" | translate }}</label>
            <select name="sex" id="sex" class="form-control {{ fieldHasErrors('sex') ? 'is-invalid' : '' }}" formControlName="sex">
              <option value="m">{{ "MALE" | translate }}</option>
              <option value="f">{{ "FEMALE" | translate }}</option>
              <option value="o">{{ "OTHER" | translate }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.sex.errors?.required">{{ "ERRRORS.INSERT_SEX" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12" *ngIf="formGroup.value.type === 'Stagista'">
            <label for="badge_number">{{ "BADGE_NUMBER" | translate }}</label>
            <input type="text" maxlength="5" minlength="1" id="badge_number" class="form-control {{ fieldHasErrors('badge_number') ? 'is-invalid' : '' }}" formControlName="badge_number" />
          </div>
          <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva'">
            <label for="vat_number">{{ "VAT_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="vat_number" maxlength="50" class="form-control {{ fieldHasErrors('vat_number') ? 'is-invalid' : '' }}" [formControlName]="'vat_number'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.vat_number.errors?.required">{{ "ERRORS.INSERT_VAT_NUMBER" | translate }}</div>
          </div>
          <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva'">
            <label for="unique_code">{{ "UNIQUE_CODE" | translate }}</label>
            <input type="text" id="unique_code" maxlength="10" class="form-control {{ fieldHasErrors('unique_code') ? 'is-invalid' : '' }}" [formControlName]="'unique_code'" />
          </div>
          <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva'">
            <label for="pec">{{ "PEC" | translate }}</label>
            <input type="text" id="pec" maxlength="255" class="form-control {{ fieldHasErrors('pec') ? 'is-invalid' : '' }}" [formControlName]="'pec'" />
          </div>
          <div class="col-12 mt-05 font-small-3" *ngIf="!!currentCollaborator && !!currentCollaborator.request && !!currentCollaborator.request.id">
            <span>{{ 'RELATED_REQUEST' | translate }}:</span>&nbsp;
            <a [routerLink]="'/dashboard/detail-request/' + currentCollaborator.request?.id" target="_blank">{{ currentCollaborator.request?.name }}</a>
          </div>
          <!--Address-->
          <div class="col-12 border-top pt-2 mt-2"></div>
          <div class="col-12 mb-1">
            <h4 class="mb-0">{{ "RESIDENCE_ADDRESS" | translate }}</h4>
          </div>
          <div class="form-group col-xl-8 col-md-6 col-12">
            <label for="address_street">{{ "ADDRESS_STREET" | translate }}</label>
            <input type="text" id="address_street" maxlength="100" [placeholder]="'ADDRESS_STREET_PLACEHOLDER' | translate" (change)="isCopingResidence = false" class="form-control" formControlName="street" />
          </div>
          <div class="col-xl-4 col-md-6 col-12 form-group" *ngIf="formGroup.value.external">
            <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              id="country"
              [items]="nationsWithCodes"
              bindLabel="name"
              bindValue="code"
              [clearable]="false"
              (change)="isCopingResidence = false"
              formControlName="country"
              [ngClass]="formGroup.controls.country.errors ? 'is-invalid' : ''"
            ></ng-select>
          </div>
          <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!formGroup.value.external">
            <label for="address_residence_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}</label>
            <input
              type="text"
              id="address_residence_zipcode"
              [placeholder]="'ADDRESS_ZIPCODE_PLACEHOLDER' | translate"
              class="form-control"
              (change)="isCopingResidence = false"
              formControlName="zipcode"
              [class]="formGroup.controls.zipcode.errors ? 'is-invalid' : ''"
              pattern="[0-9]+"
            />
            <div class="invalid-feedback" *ngIf="formGroup.controls.zipcode.errors?.required">{{ "ADDRESS_ZIPCODE_REQUIRED" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.zipcode?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.zipcode?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.zipcode?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
          </div>
          <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!formGroup.value.external">
            <label for="address_residence_city">{{ "CITY" | translate }}</label>
            <ng-select
              bindValue="id"
              bindLabel="nice_name"
              id="address_residence_city"
              [items]="_citiesService.list"
              formControlName="city_id"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              (change)="setAutoProvince('Residence'); isCopingResidence = false"
            ></ng-select>
          </div>
          <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!formGroup.value.external">
            <label for="address_residence_province">{{ "ADDRESS_PROVINCE" | translate }}</label>
            <ng-select
              bindValue="id"
              bindLabel="nice_name"
              id="address_residence_province"
              (change)="isCopingResidence = false"
              formControlName="province_id"
              [items]="_citiesService.list"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            ></ng-select>
          </div>
          <div class="form-group col-md-6 col-12 d-flex align-items-center">
            <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
            <div class="custom-control custom-control-primary custom-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitchExternal" formControlName="external" (change)="manageExternalSiteResidence()" />
              <label class="custom-control-label" for="customSwitchExternal"> </label>
            </div>
          </div>
          <!--Address Billing-->
          <div class="col-12 border-top pt-2 mt-2" *ngIf="formGroup.value.type === 'Partita iva'"></div>
          <div class="col-12 mb-1" *ngIf="formGroup.value.type === 'Partita iva'">
            <h4 class="mb-0">{{ "BILLING_ADDRESS" | translate }}</h4>
          </div>
          <div
            *ngIf="
              (formGroup.value.type === 'Partita iva' && formGroup.value.street && formGroup.value.zipcode && formGroup.value.city_id && formGroup.value.province_id) ||
              (formGroup.value.type === 'Partita iva' && formGroup.value.street && formGroup.value.external)
            "
            class="form-group col-12 pr-0 d-flex justify-content-end"
          >
            <small class="mr-1 mt-025">{{ "ADDRESS_SAME_RESIDENCE" | translate }}</small>
            <div class="custom-control custom-control-primary custom-switch">
              <input type="checkbox" class="custom-control-input" id="copyResidence" [(ngModel)]="isCopingResidence" [ngModelOptions]="{ standalone: true }" (click)="copyResidence()" />
              <label class="custom-control-label" for="copyResidence"> </label>
            </div>
          </div>
          <div class="form-group col-xl-8 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva'">
            <label for="address_billing_street">{{ "ADDRESS_STREET" | translate }}</label>
            <input
              type="text"
              id="address_billing_street"
              (change)="isCopingResidence = false"
              [placeholder]="'ADDRESS_STREET_PLACEHOLDER' | translate"
              class="form-control {{ formGroup.controls.billing_street.errors?.required ? 'is-invalid' : '' }}"
              formControlName="billing_street"
            />
            <div class="invalid-feedback" *ngIf="formGroup.controls.billing_street.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
          </div>
          <div class="col-xl-4 col-md-6 col-12 form-group" *ngIf="formGroup.value.billing_external">
            <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              id="country"
              [items]="nationsWithCodes"
              bindLabel="name"
              bindValue="code"
              (change)="isCopingResidence = false"
              [clearable]="false"
              formControlName="billing_country"
              [ngClass]="fieldHasErrors('billing_country') ? 'is-invalid' : ''"
            ></ng-select>
          </div>
          <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva' && !formGroup.value.billing_external">
            <label for="address_billing_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}</label>
            <input
              type="text"
              id="address_billing_zipcode"
              (change)="isCopingResidence = false"
              [placeholder]="'ADDRESS_ZIPCODE_PLACEHOLDER' | translate"
              formControlName="billing_zipcode"
              class="form-control {{ formGroup.controls.billing_zipcode.errors?.required ? 'is-invalid' : '' }}"
              pattern="[0-9]+"
            />
            <div class="invalid-feedback" *ngIf="formGroup.controls.billing_zipcode.errors?.required">{{ "ERRORS.INSERT_ZIP_CODE" | translate }}</div>
          </div>
          <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva' && !formGroup.value.billing_external">
            <label for="address_billing_city">{{ "CITY" | translate }}</label>
            <ng-select
              bindValue="id"
              bindLabel="nice_name"
              id="address_billing_city"
              [items]="_citiesService.list"
              formControlName="billing_city"
              [ngClass]="formGroup.controls.city_id.errors ? 'is-invalid' : ''"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              (change)="setAutoProvince('Billing'); isCopingResidence = false"
            ></ng-select>
          </div>
          <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="formGroup.value.type === 'Partita iva' && !formGroup.value.billing_external">
            <label for="address_billing_province">{{ "ADDRESS_PROVINCE" | translate }}</label>
            <ng-select
              bindValue="id"
              bindLabel="nice_name"
              id="address_billing_province"
              formControlName="billing_province"
              [class]="formGroup.controls.province_id.errors ? 'is-invalid' : ''"
              [items]="_citiesService.list"
              [closeOnSelect]="true"
              (change)="isCopingResidence = false"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            ></ng-select>
          </div>
          <div class="form-group col-md-6 col-12 d-flex align-items-center" *ngIf="formGroup.value.type === 'Partita iva'">
            <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
            <div class="custom-control custom-control-primary custom-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitchExternalBilling" formControlName="billing_external" (change)="manageExternalSiteBilling()" />
              <label class="custom-control-label" for="customSwitchExternalBilling"> </label>
            </div>
          </div>
          <!--Contract-->
          <div class="col-12 border-top pt-2 mt-2"></div>
          <div class="col-12 mb-1">
            <h4 class="mb-0">{{ "CONTRACT" | translate }}</h4>
          </div>
          <div class="form-group col-12 col-xl-3 col-md-6" *ngIf="formGroup.value.type === 'Stagista' || formGroup.value.type === 'Prestazione occasionale'">
            <label for="tutor_hash">{{ "TUTOR" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select class="{{ fieldHasErrors('tutor_hash') ? 'is-invalid' : '' }}" [closeOnSelect]="true" [clearable]="false" formControlName="tutor_hash" id="tutor_hash">
              <ng-option *ngFor="let tutor of userList" class="form-control {{ !formGroup.value.tutor_hash ? 'is-invalid' : '' }}" [value]="tutor.hash">{{ tutor.firstname }} {{ tutor.lastname }}</ng-option>
            </ng-select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.tutor_hash.errors?.required">{{ "ERRORS.INSERT_TUTOR" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="total_daily">{{ "DAILY_COST_PRESUMED" | translate }}<sup class="text-danger">*</sup></label>
            <div class="input-group input-group-merge">
              <div class="input-group-prepend">
                <span class="input-group-text">&euro;</span>
              </div>
              <input type="text" id="total_daily" [formControlName]="'total_daily'" class="form-control" (change)="formatCurrentRal()" />
            </div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="start_date">{{ "START_DATE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="date" id="start_date" [min]="today" class="form-control {{ fieldHasErrors('start_date') ? 'is-invalid' : '' }}" formControlName="start_date" />
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="end_date">{{ "END_DATE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="date" id="end_date" [min]="today" class="form-control {{ fieldHasErrors('end_date') ? 'is-invalid' : '' }}" formControlName="end_date" />
          </div>
          <!--Welcome email-->
          <div class="col-12 border-top pt-2 mt-2"></div>
          <div class="form-group col-xl-4 col-md-6 col-12 pt-2 mb-0" *ngIf="_authenticationService.hasCapability('send_welcome_email') && formGroup.value.type !== 'Da fornitore'">
            <div class="d-flex align-items-center">
              <label for="sendWelcomeEmail" class="mr-075 mb-0">{{ "SEND_WELCOME_EMAIL" | translate }}</label>
              <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
                <input id="sendWelcomeEmail" type="checkbox" checked class="custom-control-input" formControlName="send_welcome_email" />
                <label class="custom-control-label" for="sendWelcomeEmail"></label>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- file -->
      <div class="card" [ngClass]="activeTab === 'documents' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('documents')">
          <h4 class="mb-0">{{ "DOCUMENTS" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'documents' ? 'card-body' : ''" class="row">
          <!--File Upload-->
          <div class="col-xl-4 col-md-6 col-12">
            <label for="file-uploader">{{ "ENTER_MULTI_FILE" | translate }}</label>
            <div class="d-flex align-items-center">
              <div id="file-uploader" class="custom-file mr-1">
                <input class="custom-file-input" type="file" lang="it" id="file" [multiple]="true" (change)="addFileToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
              <button class="btn btn-primary" (click)="uploadFiles()" *ngIf="files_list_obj.length > 0">{{ "UPLOAD" | translate }}</button>
            </div>
          </div>
          <div class="col-12 mt-3 mb-1" *ngIf="currentCollaborator && currentCollaborator.contract_attachments && currentCollaborator.contract_attachments.length > 0">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <h3 class="mb-0">{{ "ATTACHMENTS" | translate }}</h3>
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="currentCollaborator && currentCollaborator.contract_attachments && currentCollaborator.contract_attachments.length > 0">
            <div class="row">
              <div class="col-12 d-flex align-items-center mb-05" *ngFor="let file of currentCollaborator?.contract_attachments; let i = index">
                <div class="mr-1">
                  <button
                    *ngIf="_authenticationService.hasCapability('manage_collaborator_attachments')"
                    type="button"
                    (click)="_utilService.getFile(currentCollaborator.contract_attachments[i].url)"
                    class="btn border-0 mr-1 px-0"
                    [ngbTooltip]="'VIEW' | translate"
                  >
                    <span [data-feather]="'eye'" size="16"></span>
                  </button>
                  <a class="text-danger" (click)="deleteAttachment(currentCollaborator.contract_attachments[i].id_attachment)">
                    <span [data-feather]="'trash'" size="16"></span>
                  </a>
                </div>
                <div>{{ file.filename }}</div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3" *ngIf="files_list_obj.length > 0">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <h3 class="mb-0">{{ "FILE_TO_UPLOAD" | translate }}</h3>
              </div>
              <div *ngIf="files_list_obj.length > 0 && isUploaded === 0">
                <button class="btn btn-outline-danger" (click)="resetFilesList()">{{ "RESET" | translate }}</button>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3 border-top pt-1 px-0" *ngIf="files_list_obj.length > 0">
            <div *ngFor="let file of files_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1 px-2">
              <div class="flex-basis-60 d-flex align-items-center">
                <div class="mr-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status === 0">
                  <i [data-feather]="'x'" class="text-danger" size="18"></i>
                </div>
                <div class="mt-025">{{ file.name }}</div>
              </div>
              <div class="flex-basis-20 text-right">
                <span class="badge badge-light-info" *ngIf="file.status === 0">{{ "STATUS.PENDING" | translate }}</span>
                <span class="badge badge-light-secondary" *ngIf="file.status === 1">{{ "STATUS.PROCESSING" | translate }}</span>
                <span class="badge badge-light-success" *ngIf="file.status === 2">{{ "STATUS.COMPLETED" | translate }}</span>
                <span class="badge badge-light-danger" *ngIf="file.status === 3">{{ "STATUS.ERROR" | translate }}</span>
              </div>
              <div class="flex-basis-20 text-right">{{ file.size }}</div>
            </div>
            <div class="px-2">{{ "TOTAL" | translate }}: {{ files_list_obj.length }}</div>
          </div>
          <div class="col-12 mt-3" *ngIf="!currentCollaborator?.contract_attachments || currentCollaborator?.contract_attachments?.length < 1">
            <p>{{ "NO_ONE_FILE_UPLOADED" | translate }}</p>
          </div>
        </section>
      </div>
      <!-- note -->
      <div class="card" [ngClass]="activeTab === 'notes' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('notes')">
          <h4 class="mb-0">{{ "NOTES" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'notes' ? 'card-body' : ''">
          <div id="list-notes" *ngIf="currentCollaborator && currentCollaborator.notes && currentCollaborator.notes.length > 0">
            <div class="note" *ngFor="let note of currentCollaborator.notes; let index = index">
              <header class="note-header">
                {{ _utilService.formatDate(note.create_date) }} -
                <strong>{{ note.create_by_complete_name }}</strong>
              </header>
              <div class="note-content" [innerHTML]="note.note"></div>
            </div>
          </div>
          <div class="mt-1 form-group" [formGroup]="formGroup">
            <label for="note">{{ "LABEL_ADD_NOTE" | translate }}</label>
            <textarea id="note" maxlength="300" class="form-control" [formControlName]="'note'"></textarea>
          </div>
        </section>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary text-primary mb-4" (click)="save()" *ngIf="_authenticationService.hasCapability('edit_collaborator')">{{ "EDIT" | translate }}</button>
      </div>
    </div>
  </div>
</div>
